import { motion } from "motion/react"
import { FormattedMessage } from "react-intl";
import {ANDROID_VERSION, APP_STORE_LINK, DEBIAN_URL_LATEST, DEBIAN_VERSION, GOOGLE_PLAY_LINK, IOS_VERSION, MAC_URL_LATEST, MAC_VERSION, UBUNTU_URL_LATEST, UBUNTU_VERSION, WIN_URL_LATEST, WINDOWS_VERSION} from "../privacy/constants"

export default function PageEight() {
    return (
        <motion.div
        className="mainScrollBaseContainer"
        initial={{ opacity: 0, x: 50 }}
        animate={{ opacity: 1, x: 0 }}
        exit={{ opacity: 0, x: -50 }}
        transition={{ duration: 0.5 }}
        >   
            <div className="centered main heightCenter">
                <div className="horizontal heightCenter">
                    <div>
                        <Win/>
                        <Android/>
                    </div>
                    <Lin/>
                    <div>
                        <Mac/>
                        <Ios/>
                    </div>
                </div>
            </div>
        </motion.div>
    );
}

function Win() {
    return(
        <div className="featureCard flexible centered">
            <h2 className="bold"><FormattedMessage id="windows"/></h2>
            <FormattedMessage id="windowsVersions" values={{version: WINDOWS_VERSION}}/><br/>
            <a href={WIN_URL_LATEST}>
                <img src="https://get.microsoft.com/images/en-us%20light.svg" className="storeLink"/>
            </a>
        </div>
    )
}

function Android() {
    return(
        <div className="featureCard flexible centered">
            <h2 className="bold"><FormattedMessage id="android"/></h2>
            <FormattedMessage id="androidVersions" values={{version: ANDROID_VERSION}}/><br/>
            <a href={GOOGLE_PLAY_LINK} target="_blank" rel="noreferrer">
                <img className="storeLink" src="assets/GetItOnGooglePlay_Badge_Web_color_English.png" alt=""/>
            </a>
        </div>
    )
}

function Ios() {
    return(
        <div className="featureCard flexible centered">
            <h2 className="bold"><FormattedMessage id="ios"/></h2>
            <FormattedMessage id="iosVersions" values={{version: IOS_VERSION}}/><br/>
            <a href={APP_STORE_LINK} target="_blank" rel="noreferrer">
                <img className="storeLink" src="assets/Download_on_the_App_Store_Badge_US-UK_RGB_blk_092917.svg" alt=""/>
            </a>
        </div>
    )
}

function Mac() {
    return(
        <div className="featureCard flexible centered">
            <h2 className="bold"><FormattedMessage id="macos"/></h2>
            <FormattedMessage id="macosVersions" values={{version: MAC_VERSION}}/><br/>
            <a href={MAC_URL_LATEST} target="_blank" rel="noreferrer">
                <img className="storeLink" src="assets/Download_on_the_App_Store_Badge_US-UK_RGB_blk_092917.svg" alt=""/>
            </a>
        </div>
    )
}

function Lin() {
    return(
        <div className="featureCard flexible centered">
            <h2 className="bold"><FormattedMessage id="linux"/></h2>
            <FormattedMessage id="debianVersions" values={{version: DEBIAN_VERSION}}/><br/>
            <a href={DEBIAN_URL_LATEST} download className="noUnderline">
                <button className="downloadBtn"><FormattedMessage id="downloadLatestDeb"/></button>
            </a>
            <FormattedMessage id="ubuntuVersions" values={{version: UBUNTU_VERSION}}/><br/>
            <a href={UBUNTU_URL_LATEST} download className="noUnderline">
                <button className="downloadBtn"><FormattedMessage id="downloadLatestUbu"/></button>
            </a>
        </div>
    )
}